<template>
  <v-sheet>
    <v-data-table :search="searchText" dense show-select v-model="selected" :headers="displayColumns" :items="rows" item-key="id" show-expand :single-expand="singleExpand" :expanded.sync="expanded">
      <template v-for="column in columns" v-slot:[`item.${column.value}`]="{ item }">
        <span v-if="!column.type" :key="'b' + column.value + '-' + item.id">
          {{item[column.value]}}
        </span>
        <span v-if="column.type == 'date'" :key="'date' + column.value + '-' + item.id">
          {{ item[column.value].toDate() | moment("HH:mm D/MM/YYYY") }}
        </span>
        <v-switch dense hide-details class="mt-0" v-if="column.type == 'switch'" :key="'switch' + column.value + '-' + item.id" v-model="item[column.value]" color="primary" v-on:change="change(item, column.value)"></v-switch>
      </template>      
      <template v-slot:item.participantName="{ item }">
        <a :href="`/edit/panelists/${item.participantObject.id}`" target="blank"> {{ item.participantObject.displayName }}</a>
      </template>
      <template v-slot:item.participantPhone="{ item }">
        {{ item.participantObject.phone }}
      </template>
      <template v-slot:item.role="{ item }">
        {{ item.participantObject.role == 'panelmember' ? 'Member' : 'Candidate' }}
      </template>
      <template v-slot:item.participantEmail="{ item }">
        {{ item.participantObject.email }}
      </template>
      <template v-slot:item.lastLogin="{ item }">
        <span v-if="item.participantObject.last_login">
        
        {{ item.participantObject.last_login.toDate() | moment("HH:mm D/MM/YYYY") }}
        </span>
      </template>
      <template v-slot:item.clientComments="{ item }">
        {{ item.clientComments ? item.clientComments.map( c => c.content ).join(",")  : "" }}
      </template>
      <template v-slot:item.users="{ item }">
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on }">
            <v-btn :id="item.id" icon x-small v-on="on"><v-icon>mdi-account-multiple</v-icon></v-btn>
          </template>
          <EditAppointmentUsers :appointment="item"></EditAppointmentUsers>
        </v-dialog>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="displayColumns.length">
          <EditAppointment :appointment="item"></EditAppointment>
        </td>
      </template>
      <template v-slot:top>
        <v-text-field hide-details dense rounded v-model="searchText" placeholder="Search"></v-text-field>
        <v-spacer></v-spacer>
        <AppointmentTableToolbar :columns="columns" :rows="rows" :project="project" :showColumns="showColumns" v-on:changeColumns="( c ) => showColumns = c" :selected="selected"></AppointmentTableToolbar>
      </template>      
    </v-data-table>
  </v-sheet>
</template>

<script>

import Vuex from 'vuex'
import EditAppointment from "../edits/EditAppointment.vue";
import EditAppointmentUsers from "../edits/EditAppointmentUsers.vue"
import AppointmentTableToolbar from "../tools/AppointmentTableToolbar.vue"
export default {
  name: 'AppointmentsTable',
  props: {
    project: {type: Object },
  },
  components: {
    EditAppointment,
    // MultiEdit,
    // SendCustomMessage,
    EditAppointmentUsers,
    AppointmentTableToolbar
  },
  data: () => ({
    searchText: "",
    selected: [],
    expanded: [],
    singleExpand: false,
    showColumns: ["showToClient", "dateTime", "participantName", "quota", "status", "users", "participantAttended"]
  }),
  computed: {
    ...Vuex.mapState({
        user: state => state.auth.user,
        statuses: state => state.settings.statuses,
        appointments: function(state){
          const self = this;
          var appointments = state[state.auth.view].appointments.filter( a => a.project == self.project.id );
          appointments = appointments.filter(a => a.publishStatus !== 'deleted')
          return appointments;
        },
        participants: state => {
          return state[state.auth.view].panelists
        },
    }),    
    rows(){
      this.appointments.forEach( a => {
        a.participantObject = this.participant(a)
      })
      return this.appointments;
    },
    columns(){
      var columns = [
        {
          value: "showToClient", 
          text: "Display", 
          type: "switch"
        },
        {
          value: "created",
          text: "Created", 
          type: "date",
        },
        {
          value: "dateTime",
          text: "Schedule", 
          type: "date"
        },
        {
          value: "role",
          text: "Role", 
          type: "text"
        },
        {
          value: "lastLogin",
          text: "Last Login", 
          type: "text"
        },
        {
          value: "participantName", 
          text: "Participant", 
        },
        {
          value: "participantPhone", 
          text: "Phone", 
        },
        {
          value: "participantEmail", 
          text: "Email", 
        },
        {
          value: "quota", 
          text: "Quota"
        },
        {
          value: "status",
          text: "Status", 
        },
        {
          value: "clientComments",
          text: "Comments", 
        },
        { 
          text: 'Attended',
          value: 'participantAttended',
          type: 'switch',
        },
      ];
      if( this.project.additionalFields ){
        this.project.additionalFields.forEach( field => columns.push({ text: field, value: field }))
      }
      columns.push({
        value: "consentGranted", 
        text: "Consent", 
        type: "switch"
      })
      columns.push({
        value: "users",
        text: "Users",
        width: "50px", 
        type: "button"
      })
      return columns;
    },
    displayColumns(){
      var showColumns = this.showColumns;
      return this.columns.filter( c => showColumns.indexOf(c.value) > -1 )
    }
  },
  created: function(){
    this.$store.dispatch("fetchProjectAppointments", this.project.id );
  },
  methods: {
    participant(item){      
      if( !item || !this.participants ){
        return "";
      }
      var participant = this.participants.find( a => a.id == item.participant);
      if( participant ){
        return participant 
      }
      else{
        return "";
      }
    }, 
    change(item, key){
      const self = this;
      var update = {};
      update[key] = item[key];
      self.$store.dispatch("updateDoc", { 
          doc: "appointments/"+item.id, 
          action: "update",
          data: update
        } )
    }
  }
};
</script>
